import { render, staticRenderFns } from "./withholdDeposit.vue?vue&type=template&id=27adadec&"
import script from "./withholdDeposit.vue?vue&type=script&lang=js&"
export * from "./withholdDeposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27adadec')) {
      api.createRecord('27adadec', component.options)
    } else {
      api.reload('27adadec', component.options)
    }
    module.hot.accept("./withholdDeposit.vue?vue&type=template&id=27adadec&", function () {
      api.rerender('27adadec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/dialogs/withholdDeposit.vue"
export default component.exports